module.exports = __webpack_public_path__ + "img/icon-around-7763613c.svg";